import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dev-group-func-host]',
})
export class DeviceGroupFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}